import Blog1 from "@/assets/blog-1.jpeg";
import Blog2 from "@/assets/blog-2.jpeg";
import Blog3 from "@/assets/blog-3.jpeg";
import Blog4 from "@/assets/blog-finc.jpeg";
import Blog5 from "@/assets/Blog5.jpeg";
import Case1 from "@/assets/richastory.jpg";
import BlogHero from "@/assets/bloghome.png";
import WhatsappIcon from "@/assets/icons8-whatsapp-50.png";
import { Link } from "react-router-dom";

/* ✅ YOUTUBE PLAYER COMPONENT */
const VlogCard = ({ title, videoId }) => {
  return (
    <div className="space-y-4">
      <div className="relative w-full aspect-[10/13] rounded-md overflow-hidden">
        <iframe
          className="w-full h-full"
          src={`https://www.youtube.com/embed/${videoId}`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h3 className="text-2xl lg:text-4xl font-bold text-black leading-snug">
        {title}
      </h3>
    </div>
  );
};

export default function BlogPage() {
  const blogs = [
    {
      id: 1,
      title:
        "In Uncertain Times, Can SIPs in Mutual funds Be Your Financial Umbrella?",
      img: Blog1,
      description:
        "In today’s world of rising uncertainty; wars, trade tensions, and unpredictable markets; many people wonder if it’s even the right time to invest.",
    },
    {
      id: 2,
      title:
        "Finding the Right Mutual Fund; A Journey of Dreams and Decisions",
      img: Blog2,
      description:
        "Life is a series of choices; some small, some life-changing.",
    },
    {
      id: 3,
      title: "Money, Motherhood & Mentorship; Women Shape Generations",
      img: Blog3,
      description:
        "Women play a powerful role in shaping a family's financial behaviour.",
    },
    {
      id: 4,
      title:
        "Workplace Financial Planning – A Step Towards Peace of Mind at Work",
      img: Blog4,
      description:
        "Workplace financial planning helps reduce stress and build security.",
    },
    {
      id: 5,
      title: "What If Something Goes Wrong?",
      img: Blog5,
      description:
        "A candid conversation on women and financial planning.",
    },
  ];

  const Cases = [
    {
      id: 1,
      title: "Richa’s Story: How Cash Management Changed Her Life",
      img: Case1,
      description:
        "Meet Richa, a young professional working for an MNC in Mumbai.",
    },
  ];

  /* ✅ YOUTUBE SHORTS VIDEO */
  const vlogs = [
    {
      id: 1,
      title: "When money has direction, it brings peace",
      videoId: "dMy9QF5P7wc",
    },
  ];

  return (
    <>
      {/* HERO */}
      <div
        className="relative bg-cover bg-center h-screen text-white"
        style={{ backgroundImage: `url(${BlogHero})` }}
      >
        <div className="flex flex-col items-center justify-center h-full text-center px-4">
          <h1 className="text-3xl lg:text-7xl font-bold text-[#78A742]">
            Financial Wisdom That
            <br />
            Grows with You
          </h1>
          <p className="mt-4 text-black text-lg lg:text-2xl max-w-xl">
            Read our latest insights to stay empowered on your financial journey.
          </p>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/919892147989"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-4 bg-green-600 hover:bg-green-700 text-black font-bold text-lg px-5 py-2 rounded-full flex items-center space-x-2 shadow-md"
          >
            <span>Chat Now</span>
            <img src={WhatsappIcon} className="w-8" alt="WhatsApp Icon" />
          </a>
        </div>
      </div>
{/* VLOGS */}
      <div className="px-4 py-10 lg:px-32">
        <h2 className="text-3xl lg:text-7xl font-bold text-center text-[#78A742] mb-12">
          Vlogs
        </h2>

        <div className={`grid gap-14 ${vlogs.length === 1 ? 'justify-center' : 'md:grid-cols-2'}`}>
          {vlogs.map((item) => (
            <VlogCard
              key={item.id}
              title={item.title}
              videoId={item.videoId}
            />
          ))}
        </div>
      </div>
      {/* BLOGS */}
      <div className="mt-12 px-4 py-10 lg:px-32">
        <h2 className="text-3xl lg:text-7xl font-bold text-center text-[#78A742] mb-12">
          Blogs
        </h2>

        <div className="grid md:grid-cols-2 gap-14">
          {blogs.map((blog) => (
            <Link to={`/blog/${blog.id}`} key={blog.id}>
              <img
                src={blog.img}
                alt={blog.title}
                className="rounded-md aspect-video object-cover"
              />
              <h3 className="text-xl lg:text-3xl font-bold mt-3">
                {blog.title}
              </h3>
              <p className="text-gray-700 mt-2">{blog.description}</p>
            </Link>
          ))}
        </div>
      </div>

      {/* CASE STUDY */}
      <div className="px-4 py-10 lg:px-32">
        <h2 className="text-3xl lg:text-7xl font-bold text-center text-[#78A742] mb-12">
          Case Studies
        </h2>

        {Cases.map((item) => (
          <Link to={`/case-study/${item.id}`} key={item.id}>
            <img src={item.img} className="rounded-md" />
            <h3 className="text-2xl lg:text-4xl font-bold mt-4">
              {item.title}
            </h3>
            <p className="mt-2">{item.description}</p>
          </Link>
        ))}
      </div>

      
    </>
  );
}
